<div class="map-view-cards">
    <div class="map-view">
        <p-card>
            <div #googleMap id="routes-map"></div>
        </p-card>
    </div>

    <div class="routes-sidebar">
        <div *ngIf="mapLoaded" #mapUtilities id="map-utilities">
            <div *ngFor="let route of routesDisplayed; let i = index" class="route-card-container">

                <div class="route-card" [class.expanded]="getRouteExpanded(i)" (click)="toggleRouteExpansion(i)">
                    <div class="route-top-header">
                        <div class="route-header">
                            <div class="route-color-indicator" [style.background-color]="getRouteColor(i)"></div>
                            <span class="route-title">{{ route.label }}</span>

                            <div class="route-actions">
                                <button pButton type="button" [iconOnly]="true"
                                    class="p-button-text p-button-rounded p-button-sm action-btn"
                                    (click)="$event.stopPropagation(); navigateTo(route.mapsURL)">
                                    <i class="pi pi-map"></i>
                                </button>
                                <button pButton type="button" [iconOnly]="true"
                                    class="p-button-text p-button-rounded p-button-sm action-btn"
                                    (click)="$event.stopPropagation(); changeVisibility(i)">
                                    <i [class]="route.visibility ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="route-info">
                        <div class="route-path">
                            <div class="path-visualization">
                                <i class="pi pi-truck path-icon"></i>
                                <div class="path-line-container">
                                    <div class="path-line-first"></div>
                                    <div class="path-stats">
                                        <span class="distance">{{ getFormattedDistance(route.distance) }}</span>
                                    </div>
                                    <div class="route-time">
                                        <i class="pi pi-clock"></i>
                                        <span class="time">
                                            @if(getFormattedTime(route.idealTotalTime) !=
                                            getFormattedTime(route.totalTime)) {
                                            {{ getFormattedTime(route.idealTotalTime, true)
                                            }}-{{getFormattedTime(route.totalTime) }}
                                            } @else {
                                            {{ getFormattedTime(route.totalTime) }}
                                            }
                                        </span>
                                    </div>
                                    <div class="path-line-second"></div>
                                </div>
                                <i class="pi pi-map-marker path-icon destination"></i>
                            </div>
                            <div class="path-details">
                                <div class="path-name">
                                    <div class="waypoint-line">
                                        <span class="waypoint-letter origin">A</span>
                                        <span class="location-text">{{ route.origin }}</span>
                                        <mat-icon class="arrow-icon">arrow_right_alt</mat-icon>
                                    </div>
                                    <div class="waypoint-line">
                                        <span class="waypoint-letter destination">{{ getDestinationLetter(route)
                                            }}</span>
                                        <span class="location-text">{{ route.destination }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="route-meta">
                            <div class="route-datetime">
                                <i class="pi pi-calendar"></i>
                                <span>{{ formatDateString(route.startTime) }}</span>
                            </div>
                        </div>

                        <div class="route-status">
                            <div class="optimization-status">
                                <span>Optimized</span>
                                <i
                                    [class]="route.isOptimized ? 'pi pi-check optimization-check' : 'pi pi-times optimization-cross'"></i>
                            </div>
                            @if(route.waypoints && route.waypoints.length > 0) {
                            <button pButton type="button"
                                class="p-button-text p-button-sm waypoints-toggle">
                                <i [class]="getRouteExpanded(i) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
                                View Waypoints
                            </button>
                            }
                        </div>
                    </div>

                    <div class="waypoints-section"
                        *ngIf="getRouteExpanded(i) && route.waypoints && route.waypoints.length > 0">
                        <p-timeline [value]="route.waypoints" layout="vertical" class="custom-waypoints-timeline">

                            <ng-template #marker let-waypoint>
                                <div class="waypoint-marker-timeline">{{waypoint.letter}}</div>
                            </ng-template>

                            <ng-template #opposite let-waypoint>
                                <div class="waypoint-destination">{{ waypoint.destination }}</div>
                            </ng-template>

                            <ng-template #content let-waypoint>
                                <div class="waypoint-content">

                                    <div class="waypoint-stats">
                                        <span class="stat-item-distance">
                                            {{ getFormattedDistance(waypoint.distance) }}
                                        </span>
                                        <span class="stat-item">
                                            <i class="pi pi-clock"></i>
                                            @if(getFormattedTime(waypoint.idealTime) != getFormattedTime(waypoint.time))
                                            {
                                            {{ getFormattedTime(waypoint.idealTime, true) }}-{{
                                            getFormattedTime(waypoint.time) }}
                                            } @else {
                                            {{ getFormattedTime(waypoint.time) }}
                                            }
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </p-timeline>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>